import { Component } from '@angular/core';
import { ConsoleService } from '../../console.service';

@Component({
  selector: 'app-console',
  templateUrl: './console.component.html',
  styleUrls: ['./console.component.scss']
})
export class ConsoleComponent {
  constructor(
    public consoleService: ConsoleService
  ) { }
}
